@if (user) {
  <div class="flex flex-column align-items-center">
    <span class="text-xl font-bold text-center">{{ user | formatPerson }}</span>
    @for (employment of employments; track employment) {
      <span>
        {{ employment.name | translate }} {{ employment.size }}
      </span>
    }
    @if (user.role) {
      <span
        class="px-2 py-1 mt-2 mb-3 border-round-lg"
            [ngClass]="{
                'bg-blue-400 text-primary': isActive,
                'surface-0 text-400': !isActive,
            }">
        {{ user.role.name }}
      </span>
    }
  </div>
}
